export const moneyMinorToRubles = (value: number | null | undefined): number | null => {
  if (value === null || value === undefined) {
    return null;
  }

  return Number.isFinite(value) ? value / 100 : null;
};
